import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { hiddenDate } from '../../Case/helpers/hiddenDots';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(quarterOfYear);

export const getFormattedDate = (
  date?: Date,
  viewPermission: boolean = true,
) => {
  if (!viewPermission) return hiddenDate;
  if (!date) return '-';

  const formattedDate = dayjs(date).local();
  const isValidDate = formattedDate?.isValid();
  return isValidDate ? formattedDate.format('DD MMM YYYY') : '-';
};

export const formatDateTime = (date?: string) => {
  if (!date) {
    return '-';
  }

  return dayjs(date).format('DD/MM/YYYY hh:mm A');
};

export const formatDateWithSlash = (date?: string) => {
  if (!date) {
    return '-';
  }

  return dayjs(new Date(date)).format('DD/MM/YYYY');
};

export const formatDateWithSlashAndShortYear = (date?: string) => {
  if (!date) {
    return '-';
  }

  return dayjs(new Date(date)).format('DD/MM/YY');
};
